// extracted by mini-css-extract-plugin
export default {"switchButton":"SwitchButton_switchButton__zI-DA","switcher":"SwitchButton_switcher__5UZGh","title":"SwitchButton_title__QwTje"};